import { useState } from "react";
import { Button, Col, Rate, Row } from "antd";
import moment from "moment";
import ReplyToReviewForm from "./ReplyToReviewForm";

const ReviewCard = ({ reviews }) => {
  const [isOpen, setOpen] = useState(false);
  const [initialValues, setInitialValues] = useState();

  return (
    <>
      {!!reviews?.content?.length && (
        <Row gutter={[16, 16]}>
          {reviews?.content?.map((review) => {
            const platformName =
              review?.sourceType === "TRIP_ADVISOR"
                ? "TripAdvisor"
                : review?.sourceType;
            return (
              <Col xs={24} md={12} lg={8} key={review.id}>
                <div className="review-card card h-100 shadow d-flex flex-column justify-content-between">
                  <div className="p-20">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <div className="fw-semibold heading16px mb10">
                          {review.reviewerName}
                        </div>
                        <Rate
                          allowHalf
                          defaultValue={review.rating}
                          disabled
                          style={{ fontSize: "18px" }}
                        />
                      </div>
                      <div>
                        <div className="platform-tag heading13px">
                          {platformName}
                        </div>
                        <div
                          className={`${review.sentiment.toLowerCase()}-tag heading13px mt10`}
                        >
                          {review.sentiment}
                        </div>
                      </div>
                    </div>
                    {!!review.reviewDate && (
                      <div className="mt10 mb10 text-color-848484">
                        {moment(review.reviewDate).format("MMMM D, YYYY")}
                      </div>
                    )}

                    <div className="mt10 text-justify">
                      {review.reviewText?.length > 470
                        ? `${review.reviewText?.slice(0, 470)}...`
                        : review.reviewText}
                      {review.reviewText?.length > 470 && (
                        <span
                          className="text-theme cursor-pointer fw-semibold"
                          onClick={() => {
                            setOpen(true);
                            setInitialValues(review);
                          }}
                        >
                          {" "}
                          Read more
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="response d-flex align-items-center justify-content-between">
                    <span className="heading13px text-color-848484">
                      {review.responded ? "Response sent" : "No response yet"}
                    </span>

                    <Button
                      className={
                        review.responded ? "secondary-btn" : "theme-btn"
                      }
                      type={review.responded ? "default" : "primary"}
                      style={{ gap: 0 }}
                      onClick={() => {
                        setOpen(true);
                        setInitialValues(review);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 225 225"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <g transform="translate(0,225) scale(0.1,-0.1)">
                          <path
                            d="M731 1572 c-71 -38 -71 -39 -71 -487 0 -299 3 -404 12 -413 27 -27
      55 -11 148 83 l95 95 290 0 c410 0 385 -24 385 367 0 301 -4 319 -71 355 -31
      16 -64 18 -394 18 -330 0 -363 -2 -394 -18z m753 -88 c14 -13 16 -52 16 -268
      0 -183 -3 -255 -12 -264 -9 -9 -92 -12 -311 -12 l-299 0 -64 -62 -64 -61 0
      326 c0 283 2 328 16 341 13 14 60 16 359 16 299 0 346 -2 359 -16z"
                          />
                        </g>
                      </svg>
                      {review.responded ? "Edit Response" : "Reply"}
                    </Button>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      )}

      <ReplyToReviewForm
        isOpen={isOpen}
        initialValues={initialValues}
        handleCancel={() => {
          setOpen(false);
          setInitialValues();
        }}
      />
    </>
  );
};

export default ReviewCard;
